// Copyright (c) 2019 Deere & Company

import IncentiveClaimContainer from '../../claim/incentive/state-connector';

export default {
    component: IncentiveClaimContainer,
    name: 'INCENTIVE',
    path: 'incentive/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-incentive-claim-route.js